import { Serializable } from '@admin/core/models/serializable';

export class DrivingLicense implements Serializable<DrivingLicense> {
  fromObject(obj: any): DrivingLicense {
    Object.assign(this, obj);

    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }

  public drivingLicenceId: number;

  public name: string;
}
